module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=SH - Saint Helena Ascension and Tristan da Cunha.08682477.svg";